import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const eventTypeService = createApi({
    reducerPath: 'eventTypeService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['EventType'],
    endpoints: (builder) => ({
        getAllEventType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventTypeController.getAllEventTypeWithPagination}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getEventTypeById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventTypeController.getEventTypeById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveEventType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventTypeController.saveEventType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateEventType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventTypeController.updateEventType}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteEventType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventTypeController.deleteEventType}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllEventType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventTypeController.findAllEventType}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveEventType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventTypeController.bulkSaveEventType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllEventTypeMutation,
    useGetEventTypeByIdMutation,
    useSaveEventTypeMutation,
    useUpdateEventTypeMutation,
    useDeleteEventTypeMutation,
    useFindAllEventTypeMutation,
    useBulkSaveEventTypeMutation
} = eventTypeService;
